// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';


class AddTournament extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venues: [],
      sub_categories: {},
      game_types: [],
      categories: {},
      age_groups: [],
      game_formats: [],
      tournament_details: {
        venue: '',
        venues: [],
        name: '',
        game_type: '',
        start_date: moment(),
        end_date: moment(),
        category: '',
        sub_category: '',
        age_groups: [],
        banner: '',
        game_formats: [],
        description: '',
        format_desc: '',
        prize_and_perks: '',
        registration_amount: '',
        registration_contact_number: '',
        online_registration_enabled: true,
        pay_later: false,
        is_visible:false,
        details:'',
        mobile_no:'',
      },
      data_uploaded: false,
      data_error: false,
      search: false,
      details:'',
      mobile_no:'',
      buddy_search_list:[],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.handleMultiselect = this.handleMultiselect.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.getSearchList = this.getSearchList.bind(this);
    this.setSearch = this.setSearch.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleVenue = this.handleVenue.bind(this);
    this.getTournamentInputs = this.getTournamentInputs.bind(this);

  }


  componentDidMount() {
    console.log(this.state);
  }

  componentDidMount() {
    this.getTournamentInputs();
  }

 
  getTournamentInputs() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_structure/`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {

         var tournament_details_copy =  Object.assign({}, this.state.tournament_details);
         tournament_details_copy['venue'] = data.venues[0].id;
         this.setState(          
         { 
            venues: data.venues,tournament_details: tournament_details_copy
         });
        })
       .catch(error => error);
  }  

  getSearchList() {
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({buddy_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
  setSearch(name, buddy_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.tournament_details);
        new_selected_one['buddy_id'] = buddy_id
        this.setState({tournament_details: new_selected_one, search: false});
    }


  postaddTournament(data, props) {
    console.log(data);
    const url = `${getLocationOrigin()}/eagleeye/add_tournament/`;
    const options = {...defaultOptions};
    var formData = new FormData();
    for(var name in data) {
      formData.append(name, data[name]);
    }
    options['method'] = 'post';
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          props.history.goBack();
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }

  handleChange(event) {
    const name = event.target.name;
    if(name== 'mobile_no'){
       this.setState({mobile_no:event.target.value})
    }
    else{
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = event.target.value
    this.setState({tournament_details: new_selected_one});
    }
  }
  handleMultiselect(event) {
    console.log(event);
    const name = event.target.name;
    var options = event.target.options;
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    var ids = []

    if(event){
       for (var i = 0, l = options.length; i < l; i++) {
      console.log(new_selected_one[name]);
              if (options[i].selected) {
                ids.push(options[i].value);
              }
          }
    }
    else{}
     new_selected_one[name] = ids; 
    this.setState({tournament_details: new_selected_one});
  }


  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['start_date'] = date
    this.setState({tournament_details: new_selected_one});
  }
  handleEndDate(date){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['end_date'] = date
    this.setState({tournament_details: new_selected_one});
  }

  handleVenue(event){
    console.log('handleVenue');
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one['venue'] = event.target.value
    this.setState({tournament_details: new_selected_one});
  }  


  handleFile(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['banner'] = selectorFiles[0]
    this.setState({tournament_details: new_selected_one});
  }

  handleCheck(event){
    console.log(event.target.name + event.target.checked)
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.tournament_details);
    new_selected_one[name] = event.target.checked
    this.setState({tournament_details: new_selected_one});

  }

  handleSubmit(event) {
    event.preventDefault();
    this.postaddTournament(this.state.tournament_details, this.props);
  }

  render() {
     console.log(this.state);
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12">
            <h3 style={{textAlign:'center'}}>Add Event</h3>
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Event Name *
              </div>
              <input type="text" style={styles.input} name="name" className="col-md-6 required"
                value={this.state.value} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" id="venue" className="col-md-5" style={styles.item_body} value={this.state.value}
                onChange={(e) =>{this.handleVenue(e)}}>
                {
                  Object.keys(this.state.venues).map((key, index) => (
                  <option key={index} value={this.state.venues[key].id}  >{this.state.venues[key].name}</option>
                  ))
                }
              </select>              
            </div>


            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={this.state.tournament_details.start_date} onChange={this.handleStartDate}/>
            </div>

             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Date
              </div>
              <DatePicker  selected={this.state.tournament_details.end_date} onChange={this.handleEndDate}/>
            </div>

            
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Banner *
              </div>
              <input type="file" style={styles.input} name="banner" onChange={ (e) => this.handleFile(e.target.files) }/>
            </div>



             <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Description
              </div>
              <textarea rows="4" cols="33" style={styles.input} id="description" name="description" placeholder="Description"
                onChange={this.handleChange}>
                {this.state.tournament_details.description}
                </textarea>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Tournament Partners 
              </div>
              <textarea rows="2" cols="33" style={styles.input}  name="partners" placeholder=" Tournament Partners"
                onChange={this.handleChange} />
            </div>


            <div className="col-md-12" style={styles.items}>
                        <div style={styles.item_header} className="col-md-6">
                            Coordinator
                        </div>
                        <div className="col-md-6 input-group" style={{width:'40%'}}>
                                <input type="text" name="mobile_no" className="col-md-6 form-control" 
                                placeholder="Search for.. " value={this.state.mobile_no} onChange={this.handleChange}/>
                                <span className="input-group-btn">
                                <button className="btn btn-default glyphicon glyphicon-search"
                                type="button" onClick={this.getSearchList}></button>
                                </span>
                         </div>
            </div>



                        {this.state.search?
                            <div className="col-md-12 btn-group">
                                {this.state.buddy_search_list.length?this.state.buddy_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                            <div className="alert alert-danger">Search customer not found</div>

                        </div>
                    }</div>:''}
           

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Registration Contact Number
              </div>
              <input type="number" style={styles.input} name="registration_contact_number" className="required"
                value={this.state.value} onChange={this.handleChange}/>
            </div>

            
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Online Registration
              </div>
             <input type="checkbox"
                    checked={this.state.tournament_details.online_registration_enabled}
                    ref="online_registration_enabled"
                    name="online_registration_enabled"
                    onChange={this.handleCheck}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Free Event
              </div>
             <input type="checkbox"
                    checked={this.state.tournament_details.pay_later}
                    ref="pay_later"
                    name="pay_later"
                    onChange={this.handleCheck}/>
            </div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Publish
              </div>
             <input type="checkbox"
                    checked={this.state.tournament_details.is_visible}
                    ref="is_visible"
                    name="is_visible"
                    onChange={this.handleCheck}/>
            </div>

            <div style={styles.button_submit} className="col-md-12">

              <input className="button1" type="submit" value="Submit"/>
                <p className="pull-right">* Fields are Mandatory!!</p>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default AddTournament;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addTournament/index.js